import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MetaService } from '@bo-client/core/api/meta-service';
import { combineLatestWith, map, startWith, takeUntil } from 'rxjs/operators';
import { ContactDataForm } from '@bo-client/shared/models/contactDataDto';

@Component({
  selector: 'app-contact-address-formpart',
  templateUrl: './contact-address-formpart.component.html',
  styleUrls: ['./contact-address-formpart.component.scss']
})
export class ContactAddressFormpartComponent implements OnInit, OnDestroy {
  @Input() formGroup: ContactDataForm;
  @Input() isRequired = true;

  ngUnsubscribe$: Subject<void> = new Subject<void>();

  salutations$ = of([]);
  isPerson$: Observable<boolean>;
  @Input() disable!: boolean;

  constructor(private metaService: MetaService) {
    this.salutations$ = this.metaService.salutationValues$;
  }

  ngOnInit(): void {
    this.isPerson$ = this.metaService.salutationValues$.pipe(
      combineLatestWith(
        this.formGroup.controls.salutation.valueChanges.pipe(startWith(this.formGroup.value.salutation))
      ),
      takeUntil(this.ngUnsubscribe$),
      map(([salVals, formValue]) => {
        return (
          salVals.find((SalutationValue) => SalutationValue.id === formValue)?.type?.toLowerCase() ===
          'Person'.toLowerCase()
        );
      })
    );

    this.isPerson$.subscribe({
      next: (isPerson) => {
        const { company, companyAddition, firstName, lastName } = this.formGroup.controls;
        if (isPerson) {
          this.clearValidators(company);
          this.clearValidators(companyAddition);
        } else {
          this.clearValidators(firstName);
          this.clearValidators(lastName);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  private clearValidators(control: FormControl) {
    control.clearValidators();
    control.setErrors(null);
  }
}
